import * as React from "react";

const FilenamePopover = (
  <div className="filename-popover">
    <p>
      <strong>Filename:</strong> This will be the name of the file delivered
      with the start date and end date of the <br />
      reporting period appended to the end. For example
      Myfile_[startdate]_to_[enddate].csv.
    </p>
  </div>
);

export default FilenamePopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportFormat/FilenamePopover.tsx